import React from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export const Press = (props) => {
  const sc = props.slice.primary;

  const data = useStaticQuery(graphql`
    query pressReleaseSlice {
      allPrismicPressRelease(
        limit: 3
        sort: { data: { date_published: DESC } }
        filter: { data: { hide: { eq: false } } }
      ) {
        nodes {
          _previewable
          data {
            date: date_published(formatString: "X")
            date_published(formatString: "MMMM DD, YYYY")
            resource_title {
              text
            }
            meta_image {
              gatsbyImageData
            }
            resource_label
            description {
              text
            }
          }
          url
        }
      }
    }
  `);

  const article = data.allPrismicPressRelease.nodes;

  return (
    <section className={"gutter top relative bg-" + sc.background}>
      <div className="wrapper">
        <div className="flex justify-between flex-wrap items-center mb-6">
          <h2 className="mb-0">Newsroom</h2>
          <Link to="/newsroom" className="btn bg-grey">
            View our newsroom
          </Link>
        </div>
        <div className="flex flex-col md:flex-row flex-wrap justify-center gap-8">
          {article.map((art, index) => {
            return (
              <Link
                key={index}
                to={art.url}
                className="card flex flex-col justify-between w-auto"
              >
                <span>
                  <span className="relative block">
                    <GatsbyImage
                      image={getImage(art.data.meta_image)}
                      alt={art.data.resource_title.text}
                      className="rounded-t-lg"
                    />
                    <div className="bottom-7 left-7 absolute bg-black bg-opacity-60 inline-block pr-1 pl-2 pt-1 pb-1 rounded font-bold uppercase tracking-widest text-vs text-white">
                      {art.data.resource_label}
                    </div>
                  </span>
                  <span className="p-7 block">
                  <span className="text-sm text-grey font-bold bg-grey-light py-1 px-2 rounded">
                      {art.data.date_published}
                    </span>
                    <span className="title text-xl font-bold mt-4 pr-6 block">
                      {art.data.resource_title.text}
                    </span>
                    {/* <p className="mb-4">{art.data.description.text}</p> */}
                    
                  </span>
                </span>
                <span className="pb-7 pr-7 pl-7 block">
                  <div className="btn bg-accessible-green">Read more</div>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
